<template>

  <div>
    <creating
      v-if="creating"
      height="50px" />
    
    <div v-if="!creating">
      <div
        v-if="approvalflow.requires_my_approval"
        class="card bg-light shadow-sm mb-3">
        <div class="card-header">{{ $t('Your approval') }}</div>
        <div class="card-body">
          <ApprovalflowResponse
            :approvalflowId="approvalflow._id" />
        </div>
      </div>

      <div
        :class="{'box-loading': loading}"
        class="card">
        <div class="card-header">{{ $t('Approval flow') }}</div>
        <div class="card-body">
          <div 
            v-if="permissions.includes('reset_approvalflows')"
            class="mb-3">
            <button 
              class="btn btn-sm btn-outline-secondary" 
              @click="redefinedApprovalflow()">
              {{ $t('Reset') }}
              </button>
          </div>
          <ApprovalflowProccess
            v-if="approvalflow._id"
            :approvalflow="approvalflow" />
          <div
            v-if="!approvalflow._id">
            {{ $t('There is no approval flow') }}
          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import ApprovalflowResponse from './ApprovalflowResponse'
import ApprovalflowProccess from './ApprovalflowProccess'

export default {
  name: 'Approvalflow',
  components: {
    ApprovalflowResponse,
    ApprovalflowProccess
  },
  props: {
    approvalflowId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      creating: true,
      loading: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    approvalflow () {
      return this.$store.getters.getApprovalflow
    }
  },
  watch: {
    approvalflowId: function (val) {
      this.loadData()
      this.creating = true
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('resetApprovalflow')
      .then(() => {
        if (this.approvalflowId) {
          return this.$store.dispatch('selectApprovalflow', this.approvalflowId)
        }
      })
      .then((result) => {
        this.creating = false
      })
    },
    /*
    deleteApprovalflow () {
      this.loading = true

      this.$store
      .dispatch('deleteApprovalflow', this.approvalflow._id)
      .then((result) => {
        this.loading = false
        // this.$emit('deleted', result)
      })
    },
    */
    redefinedApprovalflow () {
      const deleteAction = () => {
        this.$emit('redefined')
      }
      this.$store
      .dispatch('setAlertModal', {
        title: 'Deseja realmente redefinir o workflow de aprovação',
        message: null,
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Approvalflow/Approvalflow.vue